<template>
  <div class="product">
    <div class="thankyou">
      {{ $t('waitForRedirect') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaitForRedirect',
}
</script>

<style>
.thankyou {
  font-size: 20px;
  font-weight: 900;
}
</style>
